import React from 'react';
import ReactDOM from 'react-dom';
import './popup.css'

export default class Popup extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            vis: false,
        }

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({vis: !this.state.vis});
    }

    render() {
        return (
            <>
                <button className='broadcast_btn' onClick={this.handleClick}>Перелік тем, котрі були розглянуті</button>
                {this.state.vis && <div onClick={this.handleClick} className=' broadcast_popup popup' key={`popup-${this.props.key}`}>
                    <div className='popup_container'>
                        {this.props.topics.map((item, i) => <p className='broadcast_popup_txt'>"{item}"</p>)}
                        <button className='popup_btn'>Закрити</button>
                    </div>
                </div>}
            </>
        )
    }
}